import React from 'react';
import PropTypes from 'prop-types';
import { PaginationElement } from '../SortAndPagination.css';

const PaginationLastElement = ({ active, handleClick, totalPages }) => (
  <PaginationElement active={active}>
    <span>of</span>
    <a onClick={handleClick}>{totalPages}</a>
  </PaginationElement>
);

PaginationLastElement.propTypes = {
  active: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired
};

export default PaginationLastElement;
